/**
 * Cada entidade cacheável ganha sua própria chave aqui. O valor da chave é o
 * literal usado como chave no localStorage/sessionStorage.
 */
export enum CacheKey {
  Themes = 'themes',
  Games = 'games',
}
